import { render, staticRenderFns } from "./customer_forget_reminder.vue?vue&type=template&id=65c83ffc&scoped=true&"
import script from "./customer_forget_reminder.vue?vue&type=script&lang=js&"
export * from "./customer_forget_reminder.vue?vue&type=script&lang=js&"
import style0 from "./customer_forget_reminder.vue?vue&type=style&index=0&id=65c83ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c83ffc",
  null
  
)

export default component.exports